import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import CertificationsTotals from './CertificationsTotals';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { CardSection, CardHeader, CardWrapper } from 'foundations-components/transitional/components/Card';
import { Link } from 'quartz-routing/react-router';
import FormattedMessage from 'I18n/components/FormattedMessage';
import TopCertifications from './TopCertifications';
import CertificationsByTopicChart from './CertificationsByTopicChart';
import OverviewSectionHeader from './OverviewSectionHeader';
import ErrorBoundary from '../../../../components/Errors/ErrorBoundary';
import { CERTIFICATIONS_INDEX_PATH } from '../../constants/routes';
import { trackViewAllClick } from '../../utils/trackingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CertificationsOverview = () => {
  const {
    isLaptop
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs(View, {
    marginBlockEnd: "1000",
    children: [/*#__PURE__*/_jsx(OverviewSectionHeader, {
      button: /*#__PURE__*/_jsx(UIRouterButton, {
        onClick: () => trackViewAllClick('all-certifications'),
        size: "small",
        to: CERTIFICATIONS_INDEX_PATH,
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.myTeam.overview.certifications.viewAll"
        })
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.myTeam.overview.certifications.description"
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.myTeam.overview.certifications.title"
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "500",
      children: /*#__PURE__*/_jsx(CertificationsTotals, {})
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "stretch",
        gap: "500",
        children: [!isLaptop && /*#__PURE__*/_jsx(Box, {
          inlineSize: "50%",
          children: /*#__PURE__*/_jsx(View, {
            blockSize: "100%",
            children: /*#__PURE__*/_jsxs(CardWrapper, {
              compact: true,
              children: [/*#__PURE__*/_jsx(CardHeader, {
                title: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.myTeam.overview.certifications.certificationsByTopic.title"
                }),
                titleSize: "sm"
              }), /*#__PURE__*/_jsx(CardSection, {
                children: /*#__PURE__*/_jsx(ErrorBoundary, {
                  boundaryName: "CertificationsByTopicChart",
                  children: /*#__PURE__*/_jsx(CertificationsByTopicChart, {})
                })
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Box, {
          inlineSize: !isLaptop ? '50%' : '100%',
          children: /*#__PURE__*/_jsx(View, {
            blockSize: "100%",
            children: /*#__PURE__*/_jsxs(CardWrapper, {
              compact: true,
              children: [/*#__PURE__*/_jsx(CardHeader, {
                title: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.myTeam.overview.certifications.topCertifications.title"
                }),
                titleSize: "sm",
                toolbar: /*#__PURE__*/_jsx(Link, {
                  onClick: () => trackViewAllClick('all-top-certifications'),
                  to: CERTIFICATIONS_INDEX_PATH,
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "learningCenter.myTeam.overview.certifications.topCertifications.viewAll"
                  })
                })
              }), /*#__PURE__*/_jsx(CardSection, {
                children: /*#__PURE__*/_jsx(TopCertifications, {})
              })]
            })
          })
        })]
      })
    })]
  });
};
export default CertificationsOverview;